<textarea
  [attr.name]="id"
  [attr.id]="id"
  [attr.class]="'input-textarea ' + styleClasses"
  [attr.placeholder]="placeholder | translate"
  (input)="update($event)"
  [innerText]="precompiledValue">
</textarea>